export default __webpack_public_path__ + "static/media/event_board.3ac01722.png";